export function getCookieValue(key: string) : string {
    const b: string[] | null = document.cookie.match(`(^|;)\\s*${key}\\s*=\\s*([^;]+)`);

    if (b === null) {
        return '';
    }

    const value = b.pop();

    return value ? value : '';
}

export const currentWorkgroupKey: string = 'currentWorkgroup';


// WEBPACK FOOTER //
// ./src/utils/ajax.ts